import React, { useState, useEffect } from "react";
import { ErrorMessage } from "@hookform/error-message";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import img_sitapic from "../../assets/img/login-sitapic.png";
import { AuthLogin } from "../../service/admin/AdminService";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
const eye = <FontAwesomeIcon icon={faEye} />;
const eye1 = <FontAwesomeIcon icon={faEyeSlash} />;

function Login() {
  const navigate = useNavigate();
  const [hasShadow, setHasShadow] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setHasShadow(scrollPosition > 0);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  //handle login
  const handleLogin = ({ user, password }) => {
    setLoading(true);
    // window.location = `/dashboard-sitapic`;
    AuthLogin(user, password)
      .then((res) => {
        if (res.data.success === true) {
          localStorage.setItem("token", res.data.data.token);
          window.location = "/dashboard-sitapic";
        } else {
          setLoading(false);
          Swal.fire({
            title: " Cek Username dan Password!!",
            showConfirmButton: false,
            icon: "warning",
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        Swal.fire({
          title: err.response.data.message,
          showConfirmButton: false,
          icon: "warning",
        });
      });
  };

  const hasToken = localStorage.getItem("token");

  if (hasToken) {
    window.location = `dashboard-sitapic`;
  }

  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 30) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div>
      {/* Navbar */}
      <nav
        className={`fixed w-full z-10 top-0 font-inter transition-all duration-300 ${
          isScrolled ? "bg-white shadow-xl" : "bg-inherit"
        }`}
      >
        <div className="max-w-full mx-auto px-3 lg:px-6">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <a
                  href="/"
                  className="text-primary flex items-center font-bold text-lg lg:text-[35px]"
                >
                  SITAPIC
                </a>
              </div>
            </div>
          </div>
        </div>
      </nav>
      {/* /.navbar */}
      <section className="container mx-auto pb-12 lg:pt-12">
        <div className="grid lg:grid-cols-12 gap-4 sm:grid-cols-1 lg:my-4 lg:mx-20 mt-8">
          <div className="lg:col-span-6 sm:col-span-full m-0">
            <img
              src={img_sitapic}
              alt="logo login"
              className="lg:w-[75%] w-[60%] h-screen-full mx-auto px-12 py-12 lg:px-0"
            ></img>
          </div>
          <div className="lg:col-span-6 sm:col-span-full lg:m-0 mx-6 lg:py-40">
            <form onSubmit={handleSubmit(handleLogin)}>
              <h4 className="font-reguler text-primary text-xl mb-6 lg:text-2xl md:text-2xl">
                Login
              </h4>
              <div className="mb-4 lg:mb-8 md:mb-8">
                <input
                  className=" font-reguler appearance-none border-b-2 border-t-0 border-l-0 border-r-0 w-full py-2 lg:py-3 md:py-3 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="username"
                  type="text"
                  placeholder="Username"
                  {...register("user", {
                    required: "Username Tidak Boleh Kosong",
                  })}
                />
                <ErrorMessage
                  errors={errors}
                  name="user"
                  as={<span className="text-danger text-xs"></span>}
                />
              </div>

              <div className="mb-4 lg:mb-8 md:mb-8">
                <div className="relative">
                  <input
                    className=" font-reguler appearance-none border-b-2 border-t-0 border-l-0 border-r-0  w-full py-2 lg:py-3 md:py-3 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="password"
                    type={showPassword ? "text" : "password"}
                    {...register("password", {
                      required: "Password Tidak Boleh Kosong",
                    })}
                    placeholder="Password"
                  />

                  <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
                    {showPassword ? (
                      <i
                        className="h-5 w-5 text-gray-500 cursor-pointer"
                        onClick={togglePasswordVisibility}
                      >
                        {eye}
                      </i>
                    ) : (
                      <i
                        className="h-5 w-5 text-gray-500 cursor-pointer"
                        onClick={togglePasswordVisibility}
                      >
                        {eye1}
                      </i>
                    )}
                  </div>
                </div>
                <ErrorMessage
                  errors={errors}
                  name="password"
                  as={<span className="text-danger text-xs"></span>}
                />
              </div>
              {!isLoading && (
                <button
                  type="submit"
                  className="bg-primary hover:opacity-70 text-white text-[12px] lg:text-[16px] font-medium py-2 px-12 rounded-lg float-right shadow-xl"
                >
                  Masuk
                </button>
              )}
              {isLoading && (
                <button className="bg-primary text-[12px] lg:text-[16px]  text-white font-medium py-2 px-9 rounded-lg float-right shadow-xl disabled">
                  <svg
                    aria-hidden="true"
                    role="status"
                    className="inline w-4 h-4 me-2 text-white animate-spin"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="#E5E7EB"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentColor"
                    />
                  </svg>
                  Masuk
                </button>
              )}
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Login;
